import Sortable from 'sortablejs';

/**
 * 🏗 Directive for draggable columns on the Vuetify's data table
 * @returns custom directive
 */
export default function dataTableWithDraggableColumns() {
  return {
    inserted: (el: any, binding: any) => {
      let watchClass = (targetNode:
        any, classToWatch: any) => {
        let lastClassState =
          targetNode.classList.contains(classToWatch); const observer = new
            MutationObserver((mutationsList) => {
              for (let i = 0; i < mutationsList.length;
                i++) {
                const mutation = mutationsList[i]; if (mutation.type === "attributes" &&
                  mutation.attributeName === "class") {
                  const currentClassState =
                    (mutation.target as any).classList.contains(classToWatch); if (lastClassState
                      !== currentClassState) {
                    lastClassState = currentClassState; if
                      (!currentClassState) { (mutation.target as any).classList.add("sortHandle"); }
                  }
                }
              }
            }); observer.observe(targetNode, { attributes: true });
      };
      el.querySelectorAll("th").forEach((draggableEl: any) => {
        watchClass(draggableEl, "sortHandle");
        draggableEl.classList.add("sortHandle");
      }); Sortable.create(
        el.querySelector("tr"), binding.value ? {
          ...binding.value, handle:
            ".sortHandle"
        } : {});
    },
  }
}
